import React from "react";
import { SegmentData } from "../../../../Models/devices";
import { useState, useRef, useEffect } from "react";

interface Props {
  localPlaylist: string;
  segmentData: SegmentData[];
  cameraName: string;
  onSuccessCallback: (payload: any, isFinal: boolean, downloadTitle: string) => void;
}

const ViconDownloadVideoFromCloud = ({
  segmentData,
  localPlaylist,
  onSuccessCallback,
  cameraName,
}: Props) => {
  const [isIframeLoaded, setIsIframeLoaded] = useState(false);
  const [processedCameraName, setProcessedCameraName] = useState(
    replaceForbiddenCharacters(cameraName)
  );
  const iframeRef = useRef<any>(null);

  const onCameraNameWasChanged = () => {
    setProcessedCameraName(replaceForbiddenCharacters(cameraName));
  };

  useEffect(onCameraNameWasChanged, [cameraName]);

  function replaceForbiddenCharacters(inputString: string): string {
    return inputString.replace(/[<>:"/\\|?*]/g, "_");
  }

  useEffect(() => {
    if (isIframeLoaded && iframeRef.current) {
      const data = {
        segmentData,
        localPlaylist,
        env: {
          REACT_APP_PortalWebsite: process.env.REACT_APP_PortalWebsite,
        },
      };
      iframeRef.current?.contentWindow.postMessage(data, window.location.origin);
    }
  }, [isIframeLoaded]);

  const messageFromIFrame = (event: any) => {
    const data: any = event.data;
    if (data.source === "myiFrame" && process.env.REACT_APP_PortalWebsite === event.origin) {
      onSuccessCallback(data.payload, data.isFinal, data.title);
    }
  };
  useEffect(() => {
    window.addEventListener("message", messageFromIFrame);

    return () => {
      window.removeEventListener("message", messageFromIFrame);
    };
  }, []);

  const content = `<html>
  <head>
    <script src="/assets/ffmpeg/package/dist/umd/ffmpeg.js"></script>
    <script src="/assets/util/package/dist/umd/index.js"></script>
    
  </head>
  <body>
    <script>
      function sendMessageToParent(messageData, isFinal, title) {
        const data = {
          payload: messageData,
          source: "myiFrame",
          isFinal: isFinal,
          title: title,
        };
        window.parent.postMessage(data, "*");
      }
      const { fetchFile } = FFmpegUtil;
      const { FFmpeg } = FFmpegWASM;
      let ffmpeg = null;
      let totalPercent = 0;
      const shouldLog = false;
      
      const transcode = async (data) => {
        if (ffmpeg === null) {
          ffmpeg = new FFmpeg();
          ffmpeg.on('log', ( message ) => {
            if (shouldLog) {
              console.log(message);
            }
          });
          ffmpeg.on("progress", ({ progress }) => {
            if (progress > totalPercent) {
              sendMessageToParent(progress * 100, false, "");
            }
          });
          await ffmpeg.load({
            coreURL: "/assets/core/package/dist/umd/ffmpeg-core.js",
          });
        }

        const playlistBlob = new Blob([data.localPlaylist], { type: "text/plain" });
        const localPlaylistUrl = URL.createObjectURL(playlistBlob);
        await ffmpeg.writeFile("playlist.m3u8", await fetchFile(localPlaylistUrl));
      
        for (const [i, segment] of data.segmentData.entries()) {
          totalPercent = i / data.segmentData.length;
          sendMessageToParent(Math.floor(totalPercent * 100), false, "");
          await ffmpeg.writeFile(segment.name, await fetchFile(segment.url));
        }
      
        const timestamp = data.segmentData.length > 1
          ? data.segmentData[1].name.split(".")[0]
          : new Date().toISOString().split(".")[0].replace(/[-:]/g, "_");
        await ffmpeg.exec(["-i", "playlist.m3u8", "-c", "copy", "output.mp4"]);
        const fileData = await ffmpeg.readFile("output.mp4");
        const context = new Uint8Array(fileData);
        const url = URL.createObjectURL(new Blob([context.buffer], { type: "video/mp4" }));
        sendMessageToParent(url, true, "anavio_video_${processedCameraName}" + timestamp + ".mp4");
      };

      function handleMessage(event) {
        if (event.data && event.origin === event.data.env.REACT_APP_PortalWebsite) {
          transcode(event.data);
        }
      }
      // Attach the message event listener
      window.addEventListener("message", handleMessage);
    </script>
  </body>
</html>`;

  return (
    <div data-testid="download-video-from-cloud">
      <iframe
        ref={iframeRef}
        srcDoc={content}
        style={{ display: "none" }}
        title="Download page"
        onLoad={() => {
          // The iframe has loaded, you can now send messages
          setIsIframeLoaded(true);
        }}
      ></iframe>
    </div>
  );
};
export default ViconDownloadVideoFromCloud;
